import { toast } from 'sonner'
import {
  LINKED_TEXT_EXCLUDED_FROM_GROUP_MESSAGE,
  LINKED_TEXT_GROUP_BLOCKED_MESSAGE,
} from '@/lib/groups/linked-text-group-policy'

/**
 * Grouping dropped linked text frames (WMPCM-6948). Raised from `groupSelectedObjects`, so
 * every entry point — Ctrl/Cmd+G, Object menu, object and photo context menus — reports it
 * identically without each having to re-run the check.
 */
export function handleLinkedTextExcludedFromGroup({
  grouped,
}: {
  excludedLinkedFrameIds: string[]
  grouped: boolean
}): void {
  if (grouped) {
    toast.info(LINKED_TEXT_EXCLUDED_FROM_GROUP_MESSAGE)
    return
  }

  toast.error(LINKED_TEXT_GROUP_BLOCKED_MESSAGE)
}
